import { Dropdown } from 'primereact/dropdown';
import { Card } from "primereact/card";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from 'react';
import { IMassEmail, MassMail } from './MassMail';
import { IBenchConsultant } from '../../models/BenchConsultant';

export interface IConsultantList {
    Consultant_ID: number | null,
    Consultant_Name: string | null,
    Job_Titles: string | null,
    Phone: string | null,
    Email: string | null,
    Visa_Name: string | null,
    Location: string | null,
    City_ID: number | null,
    City_Name: string | null,
    Rate: number | null,
    F2F: string | null,
    Comment: string | null,
    State_ID: number | null,
    State_Name: string | null,
}

interface Iprops {
    singleData: (number | undefined)[] | undefined,
    setSelectedBenchs: (is: IBenchConsultant[]) => void,
    open: boolean,
    hideDialog: () => void,
    toast: any,
}

export const HotList = (props: Iprops) => {
    const [tableView, setTableView] = useState({ name: "Tabular" });
    const [mailData, setMailData] = useState("");
    const [loadData, setLoadData] = useState(true);

    const [tableData, setTableData] = useState<Array<IConsultantList>>([]);
    const [massMailVW, setMassMailVW] = useState({ data: "", open: false } as { data: string, open: boolean });

    const loadTableData = async () => {
        const response = await Fetch("Consultant_Bench_HotList", "GET", null, `q1=${props.singleData?.join(",")}`, null);
        if (response) {
            const data: IConsultantList[] = await response.json();
            setTableData(data);
            setLoadData(false);
        } else {
            setLoadData(false);
        }
    }


    const header = () => <div className="bg-blue-500 " style={{ height: "5px" }}></div>;

    const MassMailhideDialog = () => {
        setMassMailVW({ data: "", open: false });
    }

    const DataTableListString = (el: any) => {
        return (`<table style={{ border: "1px solid black", borderCollapse: "collapse", width: "100%" }}>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" , width: "25px"}}>Name</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.consultant_Name}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" , width: "25px"}}>Job Title</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.job_Titles}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" , width: "25px"}}>Phone</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.phone}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" , width: "25px"}}>Email</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.email}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" , width: "25px"}}>Location</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.location}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" , width: "25px"}}>Visa</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.visa_Name}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" , width: "25px"}}>F2F</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.f2F}</td>
            </tr>
        </table>`);

    };

    const TabularString = (el: any) => {
        return `
            <tbody>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.consultant_Name}</td>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.job_Titles}</td>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.email}</td>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.phone}</td>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.location}</td>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.visa_Name}</td>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.rate}</td>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.f2F}</td>
            </tbody>`
    }

    const DataTableList = (el: any) => {
        return (<table style={{ border: "1px solid black", borderCollapse: "collapse", width: "100%" }}>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px", width: "25px" }}>Name</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>{el.ele.consultant_Name}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px", width: "25px" }}>Job Title</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>{el.ele.job_Titles}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px", width: "25px" }}>Phone</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>{el.ele.phone}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px", width: "25px" }}>Email</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>{el.ele.email}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px", width: "25px" }}>Location</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>{el.ele.location}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px", width: "25px" }}>Visa</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>{el.ele.visa_Name}</td>
            </tr>
            <tr>
                <th style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px", width: "25px" }}>F2F</th>
                <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>{el.ele.f2F}</td>
            </tr>
        </table>);
    };

    const ListwithContactString = (el: any) => {
        return `<tbody>
            <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.consultant_Name}</td>
            <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.job_Titles}</td>
            <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.email}</td>
            <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.phone}</td>
            <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.location}</td>
            <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.visa_Name}</td>
            <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.rate}</td>
            <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.f2F}</td>
            <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>View Resume</td>
        </tbody>`
    }

    const ListwithoutContactString = (el: any) => {
        return `<tbody>
        <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.consultant_Name}</td>
        <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.job_Titles}</td>
        <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.location}</td>
        <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.visa_Name}</td>
        <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>${el.f2F}</td>
        <td style={{ border: "1px solid black", padding: "5px", textAlign: "left", fontSize: "17px" }}>View Resume</td>
    </tbody>`
    }

    const onHide = () => {
        props.hideDialog();
        setTableView({ name: "Tabular" });
        setLoadData(true);
    }

    useEffect(() => {
        if (tableView.name == "Tabular") {
            let viewData = "";
            tableData.map(el => viewData += TabularString(el));
            setMailData(`<table style={{ border: "1px solid black", borderCollapse: "collapse", width: "100%" }}>
            <thead>
                <th>Name</th>
                <th>Job Title</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Location</th>
                <th>Visa</th>
                <th>Rate</th>
                <th>F2F</th>
            </thead>
            ${viewData}
            </table>`)
        } else if (tableView.name == "List") {
            let viewData = "";
            tableData.map(el => viewData += DataTableListString(el));
            setMailData(`<div>${viewData}</div>`);
        } else if (tableView.name == "List with Contact") {
            let viewData = "";
            tableData.map(el => viewData += ListwithContactString(el));

            setMailData(`<table style={{ border: "1px solid black", borderCollapse: "collapse", width: "100%" }}>
                <thead>
                    <th>Name</th>
                    <th>Job Title</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Location</th>
                    <th>Visa</th>
                    <th>Rate</th>
                    <th>F2F</th>
                    <th>View Resume</th>
                </thead>
                ${viewData}
            </table>`);
        } else if (tableView.name == "List without Contact") {
            let viewData = "";
            tableData.map(el => viewData += ListwithoutContactString(el));
            setMailData(`<table style={{ border: "1px solid black", borderCollapse: "collapse", width: "100%" }}>
            <thead>
                <th>Name</th>
                <th>Job Title</th>
                <th>Location</th>
                <th>Visa</th>
                <th>F2F</th>
                <th>View Resume</th>
            </thead>
                ${viewData}
            </table>`);
        }
    }, [tableView.name]);

    const defaultMailBody = () => {
        let viewData = "";
        tableData.map(el => viewData += TabularString(el));
        setMailData(`<table style={{ border: "1px solid black", borderCollapse: "collapse", width: "100%" }}>
        <thead>
            <th>Name</th>
            <th>Job Title</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Location</th>
            <th>Visa</th>
            <th>Rate</th>
            <th>F2F</th>
        </thead>
        ${viewData}
        </table>`);

    }

    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);

    useEffect(() => {
        if (tableData.length > 0) defaultMailBody();
    }, [tableData]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit User" modal className="p-fluid" onHide={onHide} maximizable>
            <h1>Hot List</h1>
            <Card header={header} className="surface-200">
                <h3>Hot List type</h3>
                <Dropdown value={tableView} onChange={(e) => setTableView(e.value)} options={[{ name: "Tabular" }, { name: "List" }, { name: "List with Contact" }, { name: "List without Contact" }]} optionLabel="name" placeholder="Select a type" className="w-full md:w-14rem" />
            </Card>
            <Card>
                {tableView.name == "Tabular" && <DataTable value={tableData} showGridlines scrollable resizableColumns columnResizeMode="expand" scrollHeight="45vh" >
                    <Column field="consultant_Name" header="Name"></Column>
                    <Column field="job_Titles" header="Job Title"></Column>
                    <Column field="email" header="Email"></Column>
                    <Column field="phone" header="Phone"></Column>
                    <Column field="location" header="Location"></Column>
                    <Column field="visa_Name" header="Visa"></Column>
                    <Column field="rate" header="Rate"></Column>
                    <Column field="f2F" header="F2F"></Column>
                </DataTable>}

                {tableView.name == "List" && <div style={{ height: "45vh", overflowY: "scroll" }}>{tableData?.map((el, index) => <DataTableList key={index} ele={el} />)}</div>}

                {tableView.name == "List with Contact" && <DataTable value={tableData} showGridlines scrollable resizableColumns columnResizeMode="expand" scrollHeight="65vh" >
                    <Column field="consultant_Name" header="Name"></Column>
                    <Column field="job_Titles" header="Job Title"></Column>
                    <Column field="email" header="Email"></Column>
                    <Column field="phone" header="Phone"></Column>
                    <Column field="location" header="Location"></Column>
                    <Column field="visa_Name" header="Visa"></Column>
                    <Column field="f2F" header="F2F"></Column>
                    <Column field="" header="View Resume" body={<a href="#">View Resume</a>}></Column>
                </DataTable>}

                {tableView.name == "List without Contact" && <DataTable value={tableData} showGridlines scrollable resizableColumns columnResizeMode="expand" scrollHeight="65vh" >
                    <Column field="consultant_Name" header="Name"></Column>
                    <Column field="job_Titles" header="Job Title"></Column>
                    <Column field="location" header="Location"></Column>
                    <Column field="visa_Name" header="Visa"></Column>
                    <Column field="f2F" header="F2F"></Column>
                    <Column field="" header="View Resume" body={<a href="#">View Resume</a>}></Column>
                </DataTable>}
            </Card>
            <Button label="Send HotList" className="mt-2" loading={loadData} onClick={() => setMassMailVW({ data: mailData, open: true })} />
            <MassMail data={massMailVW.data} open={massMailVW.open} hideDialog={MassMailhideDialog} toast={props.toast} onHide={onHide} setSelectedBenchs={props.setSelectedBenchs}/>
        </Dialog>
    );
}